import { tokenPocket, tokenPocketDark } from "../../../utils";

export default {
  product: {
    title: 'Producto',
    label_1: 'KeyPal',
    label_2: 'Secret Box',
    label_3: 'Funda de cuero',
    label_4: 'Todos los accesorios',
  },
  upgrade: {
    label_1: 'Actualización',
  },
  // Descripciones bajo los títulos de "learn"
  learn: {
    label_1: 'Seguridad',
  },
  others: {
    label_1: 'Acerca de',
    label_2: 'Política de privacidad',
    label_3: 'Términos de uso',
  },
  support: {
    title: 'Soporte',
    label_1: 'Centro de ayuda',
    label_2: 'Preguntas frecuentes de compra',
    label_3: 'Comunidad',
  },
  cryptoAssets: {
    title: 'Activos criptográficos',
    label_1: 'Billetera Bitcoin',
    label_2: 'Billetera Ethereum',
    label_3: 'Billetera Solana',
    label_4: 'Billetera Tron',
    label_5: 'Billetera de stablecoins',
  }, 
  getStarted: {
    title: 'Comenzar',
    label_1: ' ¿Cómo mantener segura tu billetera?',
    label_2: '¿Cómo usar KeyPal 2?',
    label_3: '¿Cómo usar KeyPal Card?',
    label_4: '¿Cómo usar KeyPal Plus?',
    label_5: ' ¿Cómo usar Secret Box?',
  }, 
  download: {
    title: 'Download',
    label_1: 'Mobile Wallet',
    label_2: 'Extension wallet',
    label_3: 'Upgrade',
  }, 
  legal: {
    title: 'Legal',
    label_1: 'Privacy Policy',
    label_2: 'Terms of Use',
  }, 

  designed: `Designed by ${tokenPocket} with ❤️`,
  designedDark: `Designed by ${tokenPocketDark} with ❤️`,
}
